/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./AvailableAssetFilters.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { CpeField } from "data/@types";

import { AvailableAssetFiltersState as RAvailableAssetFiltersState , slice } from "store/company/availableAssetFilters.slice";
import { AvailableAssetFiltersProps, AvailableAssetFiltersState } from "./AvailableAssetFilters.types";

import Widget from "components/ThreeKey/Widget";
import InputDropDown from "components/ThreeKey/InputDropDown";
import ColumnGrid, { ColumnGridColumn } from "components/ThreeKey/ColumnGrid";


class AvailableAssetFilters extends React.Component<AvailableAssetFiltersProps, AvailableAssetFiltersState> {

   public componentDidMount(): void {
      this.props.actions.loadVendors({});
   }


   public render(): React.ReactNode {

      const availableAssetFiltersData: ColumnGridColumn[] = [
         { label: "Part", items: this.props.availableAssetFilters.parts.map(part => { return { id: part, data: part } }) },
         { label: "Version", items: this.props.availableAssetFilters.versions.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "Update", items: this.props.availableAssetFilters.updates.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "Edition", items: this.props.availableAssetFilters.editions.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "Language", items: this.props.availableAssetFilters.languages.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "SW edition", items: this.props.availableAssetFilters.swEditions.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "Target SW", items: this.props.availableAssetFilters.targetSWs.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "Target HW", items: this.props.availableAssetFilters.targetHWs.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) },
         { label: "Other", items: this.props.availableAssetFilters.others.map(data => { return data === "*" ? { id: "any", data: "" } : { id: data, data } }) }
      ]

      return (

         <Widget componentName="filter-criteria" caption="Select Assets" isLoading={this.props.isLoading}>

            <div className="available-asset-filters-component">

               <div className="vendor-product">

                  <div className="vendor">
                     <label htmlFor="vendor">Vendor</label>
                     <InputDropDown
                        id="vendor"
                        componentName="vpv"
                        isLoading={this.props.availableAssetFilters.vendorsLoading}
                        isLoadingNext={this.props.availableAssetFilters.nextVendorsLoading}
                        items={this.props.availableAssetFilters.vendors}
                        value={this.props.availableAssetFilters.selectedVendor}
                        dropDownOnKeyDown={true}
                        dropDownOnFocus={true}
                        onChange={this.onVendorChanged}
                        onLoadNext={this.onVendorsFetchNext}
                        canClear={true}
                     />
                  </div>

                  <div className="product">
                     <label htmlFor="product">Product</label>
                     <InputDropDown
                        id="product"
                        componentName="vpv"
                        isLoading={this.props.availableAssetFilters.productsLoading}
                        isLoadingNext={this.props.availableAssetFilters.nextProductsLoading}
                        items={this.props.availableAssetFilters.products}
                        value={this.props.availableAssetFilters.selectedProduct}
                        dropDownOnKeyDown={true}
                        dropDownOnFocus={true}
                        canClear={true}
                        onChange={this.onProductChanged}
                        onLoadNext={this.onProductsFetchNext}
                     />
                  </div>

               </div>

               <div className="container">
                  <ColumnGrid
                     columns={availableAssetFiltersData}
                     selectableItems={true}
                     onItemDblClick={this.onFilterCriteriaPlusDblClick}
                     isLoading={this.props.availableAssetFilters.availableAssetFiltersLoading}
                  />
               </div>

            </div>

         </Widget>

      )

   }

   private onFilterCriteriaPlusDblClick = (columnIndex: number, value: string) => {

      const cpeFields: CpeField[] = [ "part", "version", "update", "edition", "language", "sw_edition", "target_sw", "target_hw"];

      this.props.actions.addAvailableAssetFilterCriteria({
         field: cpeFields[columnIndex],
         value: value,
         operator: "eq",
         negate: false
      })

   }


   private onVendorChanged = (vendor: string, fetchProducts: boolean = true) => {

      if (vendor === this.props.availableAssetFilters.selectedVendor) return;
      this.props.actions.selectVendor({ vendor });

   }

   private onProductChanged = (product: string) => {

      if (product === this.props.availableAssetFilters.selectedProduct) return;
      this.props.actions.selectProduct({ product });

   }

   private onVendorsFetchNext = () => {

      this.props.actions.loadNextVendors({});
   }

   private onProductsFetchNext = () => {

      this.props.actions.loadNextProducts({});

   }


}


const mapStateToProps = (state: {
   availableAssetFilters: RAvailableAssetFiltersState, // redux state interface
}) => {
   return state;
}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            slice.actions
         ),
         dispatch
      )
   }

}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(AvailableAssetFilters);